(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-slider"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){
  try {
    $('[data-section-type="collection-slider"] .slider__content').slick({
      dots: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: '<button class="slick-prev" aria-label="Previous" type="button" style="background-image: url(https://cdn.shopify.com/s/files/1/0458/5983/1959/files/left.svg?v=1696807717);"></button>',
      nextArrow: '<button class="slick-next" aria-label="Next" type="button" style="background-image: url(https://cdn.shopify.com/s/files/1/0458/5983/1959/files/chevron.svg?v=1696807652);"></button>',
    });
  } catch (error) {
    console.error("Slider initialization failed:", error);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-slider"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){
  try {
    $('.slider__content').slick({
      dots: true,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      prevArrow: '<button class="slick-prev" aria-label="Previous" type="button" style="background-image: url(https://cdn.shopify.com/s/files/1/0458/5983/1959/files/left.svg?v=1696807717);"></button>',
      nextArrow: '<button class="slick-next" aria-label="Next" type="button" style="background-image: url(https://cdn.shopify.com/s/files/1/0458/5983/1959/files/chevron.svg?v=1696807652);"></button>',
      responsive: [
        {
          breakpoint: 700,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
    });
  } catch (error) {
    console.error("Slider initialization failed:", error);
  }
});

  } catch(e) { console.error(e); }
})();
})();
